module.exports = react-native-sqlite-2;